import { gql } from "@apollo/client";

export const CARD_AS_DEFAULT = gql`
  mutation setCardAsDefault($cardId: String!) {
    setCardAsDefault(
      cardId: $cardId,
    ) {
      card {
        id,
      },
      success,
      messages,
    }
  }`;
